export default __webpack_public_path__ + "static/small_thumb_lux_logo@2x-81ce9452fd58af90a229e8dd62b32cfd.png";